<div
  class="nav-shell"
  [class.is-expanded]="isExpanded"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <div class="nav-header">
    <div class="brand">
      <div class="brand-icon" aria-hidden="true">
        <img src="assets/manager-favicon.svg" alt="iManager" />
      </div>
      <div class="brand-text">
        <span class="brand-name"><span class="brand-i">i</span>Manager</span>
        <span class="brand-subtitle">Portal de Gestão</span>
      </div>
    </div>
    <button
      class="nav-toggle"
      type="button"
      (click)="togglePinned()"
      [attr.aria-label]="isPinned ? 'Soltar menu' : 'Fixar menu'">
      <i class="pi" [ngClass]="isPinned ? 'pi-lock' : 'pi-lock-open'"></i>
    </button>
  </div>

  <nav class="nav-items" aria-label="Menu principal">
    <ul class="nav-list">
      <ng-container *ngFor="let grupo of filteredGrupos">

        <!-- Label do grupo (ex: OPERAÇÃO / CONFIGURAÇÃO) -->
        <!-- Wrapper mantem altura fixa em ambos estados — evita shift vertical dos icones -->
        <li class="nav-group-label-item" role="presentation">
          <div
            class="nav-group-label"
            [attr.aria-label]="'Grupo ' + grupo.label">
            <span class="nav-group-label-full">{{ grupo.label }}</span>
            <span class="nav-group-label-short" aria-hidden="true">{{ getGrupoAbrev(grupo.label) }}</span>
          </div>
        </li>

        <!-- Itens do grupo -->
        <ng-container *ngFor="let item of grupo.items; let i = index">
          <li
            class="nav-group"
            [class.has-children]="item.children?.length"
            [class.is-disabled]="item.disabled"
            [attr.data-tour]="item.tourId ?? null"
            [attr.aria-disabled]="item.disabled || null"
            routerLinkActive="active">

            <!-- Item desabilitado (em breve) -->
            <ng-container *ngIf="item.disabled; else itemAtivo">
              <span
                class="nav-item nav-item--disabled"
                [attr.aria-label]="(item.aria || item.label) + ' — em breve'"
                [attr.title]="item.label"
                aria-disabled="true">
                <i class="pi nav-icon" [ngClass]="item.icon"></i>
                <span class="nav-label">
                  {{ item.label }}
                  <small *ngIf="item.hint" class="nav-item-hint">({{ item.hint }})</small>
                </span>
              </span>
            </ng-container>

            <!-- Item ativo (link ou externo) -->
            <ng-template #itemAtivo>
              <ng-container *ngIf="!item.children?.length; else itemComFilhos">
                <a
                  *ngIf="!item.externalUrl; else externalLink"
                  class="nav-item"
                  [routerLink]="item.route"
                  [queryParams]="item.queryParams"
                  [attr.aria-label]="item.aria || item.label"
                  [attr.title]="item.label"
                  (click)="navClicked.emit()">
                  <i class="pi nav-icon" [ngClass]="item.icon"></i>
                  <span class="nav-label">{{ item.label }}</span>
                </a>
                <ng-template #externalLink>
                  <a
                    class="nav-item"
                    [href]="item.externalUrl"
                    target="_blank"
                    rel="noopener"
                    [attr.aria-label]="item.aria || item.label"
                    [attr.title]="item.label"
                    (click)="navClicked.emit()">
                    <i class="pi nav-icon" [ngClass]="item.icon"></i>
                    <span class="nav-label">{{ item.label }}</span>
                  </a>
                </ng-template>
              </ng-container>

              <ng-template #itemComFilhos>
                <button
                  class="nav-item"
                  type="button"
                  (click)="toggleItem(item)"
                  [attr.aria-label]="item.aria || item.label"
                  [attr.aria-expanded]="item.expanded"
                  [attr.aria-controls]="'submenu-' + grupo.label + '-' + i"
                  [attr.title]="item.label">
                  <i class="pi nav-icon" [ngClass]="item.icon"></i>
                  <span class="nav-label">{{ item.label }}</span>
                  <i class="pi nav-chevron" [ngClass]="item.expanded ? 'pi-angle-down' : 'pi-angle-right'"></i>
                </button>
                <div class="nav-subitems" [id]="'submenu-' + grupo.label + '-' + i" [class.open]="item.expanded">
                  <ng-container *ngFor="let child of item.children">
                    <ng-container *ngIf="!child.adminOnly || isGestorUser">
                      <a
                        *ngIf="child.route && !child.disabled; else disabledChild"
                        class="nav-subitem"
                        [routerLink]="child.route"
                        [queryParams]="child.queryParams"
                        routerLinkActive="active"
                        [attr.aria-label]="child.aria || child.label"
                        [attr.title]="child.label"
                        (click)="navClicked.emit()">
                        <span class="sub-dot"></span>
                        <span class="nav-label">{{ child.label }}</span>
                      </a>
                      <ng-template #disabledChild>
                        <div class="nav-subitem is-disabled" [attr.aria-label]="child.aria || child.label">
                          <span class="sub-dot"></span>
                          <span class="nav-label">{{ child.label }}</span>
                        </div>
                      </ng-template>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-template>
            </ng-template>

          </li>
        </ng-container>

        <!-- Separador entre grupos (não aparece após o último grupo) -->
        <li *ngIf="!isUltimoGrupo(grupo)" class="nav-separator" role="separator" aria-hidden="true"></li>

      </ng-container>
    </ul>
  </nav>

  <div class="nav-footer">
    <div class="user-card" data-tour="menu-perfil">
      <div class="user-avatar" aria-hidden="true">
        <img *ngIf="avatarUrl" [appAuthSrc]="avatarUrl" alt="Avatar" class="user-avatar-img" />
        <span *ngIf="!avatarUrl">{{ userInitials }}</span>
      </div>
      <div class="user-info">
        <span class="user-name" [attr.title]="userName">{{ userName }}</span>
        <span class="user-role">{{ userRole }}</span>
      </div>
      <div class="user-actions">
        <button
          class="user-settings"
          type="button"
          aria-label="Meu Perfil"
          pTooltip="Meu Perfil"
          [tooltipStyleClass]="'menu-tooltip'"
          tooltipPosition="top"
          (click)="abrirConfiguracoes()">
          <i class="pi pi-user"></i>
        </button>
        <button
          class="user-logout"
          type="button"
          (click)="logout.emit()"
          aria-label="Sair"
          pTooltip="Sair"
          [tooltipStyleClass]="'menu-tooltip'"
          tooltipPosition="top">
          <i class="pi pi-sign-out"></i>
        </button>
      </div>
    </div>
  </div>
</div>
